export * from "./getSubscriptionConfigurations.endpoint";
